module.exports = __webpack_public_path__ + "img/zyg.99b1c927.png";